import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';

const FeaturesList = ({ items = [], reverseColumns = false }) => {
  const [activeImageId, setActiveImageId] = useState(null);
  const imageContainerRef = useRef(null);

  useEffect(() => {
    if (items && items.length > 0) {
      setActiveImageId(items[0]?.image?.id);
      items.forEach((item) => {
        const imageDiv = document.getElementById(`img-box-${item?.image?.id}`);
        const image = document.getElementById(`img-${item?.image?.id}`);
        if (imageDiv && image) {
          imageDiv.innerHTML = '';
          imageDiv.appendChild(image.cloneNode(true));
        }
      });
    }
  }, [items]);

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className={cn(styles.contentWrapper, { [styles.reverseColumns]: reverseColumns })}>
      {/* Left Side - Items List */}
      <div className={styles.itemsList}>
        {items.map((item) => {
          const isActive = item?.image?.id === activeImageId;
          if (!item?.image?.id) {
            return null;
          }
          return (
            <div
              key={`item-${item?.image?.id}`}
              className={cn(styles.item, {
                [styles.active]: isActive,
              })}
            >
              <button
                type="button"
                className={styles.itemButton}
                onClick={() => setActiveImageId(item?.image?.id)}
              >
                <div className={styles.itemTitle}>{item.title}</div>
                {item.description && <p className={styles.itemDescription}>{item.description}</p>}
              </button>
            </div>
          );
        })}
      </div>

      {/* Right Side - Active Item Image */}
      <div className={styles.imageContainer} ref={imageContainerRef}>
        {items.map((item) => (
          <div
            key={`img-box-${item?.image?.id}`}
            className={cn(styles.imageBox, {
              [styles.active]: item?.image?.id === activeImageId,
            })}
            id={`img-box-${item?.image?.id}`}
          />
        ))}
      </div>
    </div>
  );
};


FeaturesList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      image: PropTypes.shape({
        id: PropTypes.number.isRequired,
      }),
    })
  ),
  reverseColumns: PropTypes.bool,
};

export default FeaturesList;
